<h3 class="text-center" style="color: #5A1727">Informe</h3>
<mat-horizontal-stepper linear #stepper>
  <mat-step [stepControl]="datosColaborador" [editable]="isEditable">
    <form [formGroup]="datosColaborador" autocomplete="off">
      <ng-template matStepLabel>Colaborador</ng-template>
      <h3 class="text-left" style="color: #5A1727">Datos Colaborador</h3>
      <hr>
      <mat-form-field appearance="outline" class="col-lg-4  col-md-6 col-sm-12">
        <mat-label>NIF/CIF/NIE</mat-label>
        <input matInput matNativeControl type="text" [class.is-invalid]="nif2NoValido" formControlName="nif">
        <small *ngIf="nif2NoValido">
          El NIF/CIF/NIE es <strong>requierido</strong>, Minimo 9 caracteres
        </small>
      </mat-form-field>

      <mat-form-field appearance="outline" class="col-lg-4 col-md-6 col-sm-12">
        <mat-label>Primer apellido, razón social o denominación</mat-label>
        <input matInput matNativeControl type="text" [class.is-invalid]="denominacionNoValido"
               formControlName="apellido1">
        <small *ngIf="denominacionNoValido">
          Primer apellido, razón social o denominación es <strong>requerido</strong>
        </small>
      </mat-form-field>

      <mat-form-field appearance="outline" class="col-lg-4 col-md-6 col-sm-12">
          <mat-label>Sexo</mat-label>
          <select matInput matNativeControl formControlName="sexo">
            <option label="--Seleccionar--"></option>
            <option value="MUJER">MUJER</option>
            <option value="HOMBRE">HOMBRE</option>
            <option value="EMPRESA">EMPRESA</option>
          </select>
      </mat-form-field>
      <!---- Boton siguiente ------------>
      <div class="text-center mt-5">
        <button mat-button type="submit" class="btn-secondary" matStepperNext>Siguiente</button>
      </div>
    </form>
  </mat-step>

  <!---- Stepper 2 Datos vehiculo ------>
  <mat-step [stepControl]="datosVehiculos" [editable]="isEditable">
    <form [formGroup]="datosVehiculos" autocomplete="off">
      <ng-template matStepLabel>Vehículo </ng-template>
      <h3 class="text-left" style="color: #5A1727">Datos Vehículos</h3>
      <hr>

      <div class="row">
        <div class="col-lg-4"></div><!--
        <mat-form-field appearance="outline" class="col-lg-3 col-md-6 col-sm-12">
          <mat-label>Nº Bastidor (E)</mat-label>
          <input matInput matNativeControl type="text" formControlName="bastidor" matTooltip="Ultimas cuatro dicfras del bastidor."
                 onkeydown="return /[A-HJ-NPR-Za-hj-npr-z\d]/i.test(event.key)" maxlength="17">
        </mat-form-field>

        <div class="col-lg-2 alinea">
          <p class="center"> ó </p>
        </div>-->
        
        <mat-form-field appearance="outline" class="col-lg-3 col-md-6 col-sm-12">
          <mat-label>Matrícula</mat-label>
          <input matInput matNativeControl type="text"  formControlName="matricula"
                 placeholder="Matricula">
        </mat-form-field>

        <div class="col-lg-2"></div>

      </div>
    <div class="row mt-5">
      <div class="col-4 text-right">
        <button mat-button class="btn-danger" matStepperPrevious>Atras</button>
      </div>
      <div class="col-4 text-center">
        <button mat-button class="btn-secondary" (click)="stepper.reset()">Restablecer</button>
      </div>
      <div class="col-4 text-left">
        <button mat-button class="btn-info" (click)="guardar()">Guardar</button>
      </div>
    </div>
    </form>
  </mat-step>
</mat-horizontal-stepper>

